import { LineChart, Line, BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend, ReferenceLine } from 'recharts';
import { useNumberFormat } from '../../lib/numberFormat';

const COLORS = { revenue: '#0D9488', ebitda: '#1E293B', cash: '#10B981', expenses: '#F59E0B', gross_profit: '#0284C7', base: '#0D9488', upside: '#0284C7', downside: '#B45309' };

function toData(labels, series) {
  return labels.map((l, i) => Object.fromEntries([['label', l], ...Object.entries(series).map(([k, v]) => [k, v[i] ?? null])]));
}

export function TrendChart({ labels, series, currency, kind = 'line', names = {}, testId }) {
  const { compact } = useNumberFormat();
  const data = toData(labels, series);
  const Chart = kind === 'bar' ? BarChart : LineChart;
  return <div className="h-64 w-full" data-testid={testId}>
    <ResponsiveContainer minWidth={0} minHeight={256} initialDimension={{ width: 360, height: 256 }}>
      <Chart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <CartesianGrid stroke="#E2E8F0" vertical={false} />
        <XAxis dataKey="label" tick={{ fontSize: 11, fill: '#64748B' }} interval="preserveStartEnd" tickLine={false} axisLine={{ stroke: '#E2E8F0' }} />
        <YAxis tick={{ fontSize: 11, fill: '#64748B', fontFamily: 'IBM Plex Mono' }} tickFormatter={(v) => compact(v, currency)} width={64} tickLine={false} axisLine={false} />
        <Tooltip formatter={(v, n) => [compact(v, currency), names[n] || n]} contentStyle={{ fontSize: 12, borderRadius: 6, borderColor: '#E2E8F0' }} />
        <Legend formatter={(n) => names[n] || n} wrapperStyle={{ fontSize: 12 }} />
        <ReferenceLine y={0} stroke="#94A3B8" />
        {Object.keys(series).map((k) => kind === 'bar'
          ? <Bar key={k} dataKey={k} fill={COLORS[k] || '#0D9488'} radius={[2, 2, 0, 0]} isAnimationActive={false} />
          : <Line key={k} type="monotone" dataKey={k} stroke={COLORS[k] || '#0D9488'} strokeWidth={2} dot={false} isAnimationActive={false} strokeDasharray={k === 'downside' ? '4 3' : undefined} />)}
      </Chart>
    </ResponsiveContainer>
  </div>;
}
